<template>
  <f7-page v-if="user" name="parameters">
    <f7-navbar :title="$t('title')" />
    <f7-list media-list inset>
      <f7-list-item :title="username" :subtitle="email" :class="{'text-align-center': !photoURL }">
        <img v-if="photoURL" slot="media" :src="photoURL" width="44">
      </f7-list-item>
      <f7-list-button v-if="user.isAnonymous" :title="$t('anonymousAccount-upgrade')" href="/p/account-permanentify/" />
      <f7-list-button v-else :title="$t('manageAccount')" href="/p/account-management/" />
      <f7-list-button v-if="user.isAnonymous" :title="$t('anonymousAccount-delete')" color="red" @click="deleteUser" />
      <f7-list-button v-else :title="$t('disconnect')" color="red" @click="logout" />
    </f7-list>
    <f7-list>
      <f7-list-item :title="$t('stats')" link="/p/stats/" />
      <f7-list-item :title="$t('hashtags')" link="/hashtags/" />
    </f7-list>
    <f7-list>
      <f7-list-item :title="$t('featureRequest')" link="https://shipright.community/kipinto" external target="_blank" />
      <f7-list-item :title="$t('contactUs')" link="mailto:contact@kipinto.ch" external :target="$f7.device.cordova ? '_system' : '_self'" />
    </f7-list>
    <f7-list>
      <f7-list-item
        smart-select
        :smart-select-params="{ 'closeOnSelect': true }"
        :title="$t('language')"
      >
        <select v-model="$root.$i18n.locale" name="language">
          <option value="en">
            English
          </option>
          <option value="fr">
            Français
          </option>
        </select>
      </f7-list-item>
      <f7-list-item :title="$t('calendar')" link="/p/calendar/" />
      <f7-list-item :title="$t('backupRestore')" link="/p/backup-restore/" />
    </f7-list>
    <f7-list>
      <f7-list-button :title="$t('restart')" @click="reloadApp" />
    </f7-list>

    <f7-block v-if="pendingWrites" class="text-align-center">
      <f7-chip :text="$tc('pendingWrites', pendingWrites)" media-bg-color="orange" color="orange" @click="showSyncInfo">
        <f7-icon slot="media" ios="f7:arrow_2_circlepath" aurora="f7:arrow_2_circlepath" md="material:sync" />
      </f7-chip>
    </f7-block>

    <template v-if="release !== 'prod' && release !== 'beta'">
      <f7-block-title>Development / Beta tools</f7-block-title>
      <f7-list>
        <f7-list-button title="Forget Language" @click="forgetLanguage" />
        <f7-list-button title="Forget Intro" @click="forgetIntro" />
        <!-- <f7-list-button title="Load Contacts" @click="loadContacts" /> -->
        <!-- <f7-list-button id="backup" title="Backup" @click="backup" /> -->
      </f7-list>
    </template>
    <f7-block-footer>v3.31.2 {{ target === 'web' ? release : '' }}</f7-block-footer>

    <f7-block>
      <a href="/p/legals/?tab=legals">Mentions Légales</a><br>
      <a href="/p/legals/?tab=privacy">Politique de Confidentialité</a><br>
      <a href="/p/legals/?tab=tos">CGU</a>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapGetters } from 'vuex';

import firebase from '../js/firebase-config'; // REDUCE SIZE
import dummyContacts from '../dummy/contacts.json';
import dummyInteractions from '../dummy/interactions.json';

export default {
  data() {
    return {
      release: process.env.RELEASE || 'dev',
      target: process.env.TARGET || 'web',
    };
  },
  computed: {
    ...mapGetters([
      'user',
      'pendingWrites',
    ]),
    username() {
      return this.user.isAnonymous ? this.$t('anonymousAccount-displayName') : this.user.displayName;
    },
    email() { return this.user ? this.user.email : null; },
    photoURL() { return this.user ? this.user.photoURL : null; },
  },
  watch: {
    '$root.$i18n.locale': (newLocale) => {
      console.log('User set a new language', newLocale);
      // We try to save the choice of the user
      try {
        localStorage.setItem('locale', newLocale);
      } catch (error) { console.error(error); }
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    deleteUser() {
      this.$f7.dialog.confirm(
        this.$t('anonymousAccount-delete-warning'),
        this.$t('anonymousAccount-delete'),
        () => {
          this.$store.dispatch('deleteUser');
        },
      );
    },
    showSyncInfo() {
      this.$f7.dialog.alert(this.$t('syncExplanation'), this.$tc('pendingWrites', this.pendingWrites));
    },
    forgetLanguage() {
      // We try to forget the choice of the user
      try {
        localStorage.removeItem('locale');
      } catch (error) { console.error(error); }
    },
    forgetIntro() {
      // We try to forget that we have seen the intro
      try {
        localStorage.removeItem('introRead');
      } catch (error) { console.error(error); }
    },
    reloadApp() {
      window.location.reload();
    },
    loadContacts() {
      console.log('Starting import of dummy contacts');
      let importSuccess = 0;
      let importFail = 0;
      const contactsId = [];
      function incrementSuccess() {
        importSuccess += 1;
        return importSuccess;
      }
      function incrementFail() {
        importFail += 1;
        return importFail;
      }
      function getSucess() {
        return importSuccess;
      }
      function getFail() {
        return importFail;
      }
      function insertContactId(contactId) {
        contactsId.push(contactId);
        return contactsId;
      }
      function getContactsId() {
        return contactsId;
      }
      const _this = this;
      for (let i = 0; i < dummyContacts.length; i++) {
        // We update the "date" fields so they are interpreted as date by Firebase
        dummyContacts[i].metadata.updated = new Date(
          dummyContacts[i].metadata.updated,
        );
        dummyContacts[i].metadata.created = new Date(
          dummyContacts[i].metadata.created,
        );
        // We import into firebase
        firebase
          .firestore()
          .collection(`users/${firebase.auth().currentUser.uid}/contacts`)
          .add(dummyContacts[i])
          // If we successfully saved the contact
          .then((docRef) => {
            console.log('New contact created with ID: ', docRef.id);
            insertContactId(docRef.id);
            incrementSuccess();
            // We announce the result of the import
            if (getSucess() + getFail() === dummyContacts.length) {
              _this.$f7.dialog.alert(
                `ImportSuccess: ${getSucess()} ; ImportFail: ${getFail()}`,
              );
              _this.loadInteractions(getContactsId());
            }
          })
          // If creating the contact failed
          .catch((error) => {
            console.error('Error creating the contact: ', error);
            incrementFail();
            // We announce the result of the import
            if (getSucess() + getFail() === dummyContacts.length) {
              _this.$f7.dialog.alert(
                `ImportSuccess: ${getSucess()} ; ImportFail: ${getFail()}`,
              );
              _this.loadInteractions(getContactsId());
            }
          });
      }
    },
    loadInteractions(contactsId) {
      console.log('Starting import of dummy interactions');
      for (let i = 0; i < dummyInteractions.length; i++) {
        // We update the "date" fields so they are interpreted as date by Firebase
        dummyInteractions[i].metadata.updated = new Date(
          dummyInteractions[i].metadata.updated,
        );
        dummyInteractions[i].metadata.created = new Date(
          dummyInteractions[i].metadata.created,
        );
        dummyInteractions[i].date = new Date(
          dummyInteractions[i].date,
        );
        dummyInteractions[i].contacts = [];
        const nbContacts = Math.ceil(Math.random() * 3);
        for (let c = 0; c < nbContacts; c++) {
          dummyInteractions[i].contacts.push(contactsId[Math.floor(Math.random() * contactsId.length)]);
        }
        // We import into firebase
        firebase
          .firestore()
          .collection(`users/${firebase.auth().currentUser.uid}/interactions`)
          .add(dummyInteractions[i])
          // If we successfully saved the contact
          .then((docRef) => {
            console.log('New interaction created with ID: ', docRef.id);
          })
          // If creating the contact failed
          .catch((error) => {
            console.error('Error creating the interaction: ', error);
          });
      }
    },
  },
};
</script>

<i18n>
{
  "en": {
    "language": "Language",
    "title": "Parameters",
    "disconnect": "Disconnect",
    "manageAccount": "Manage Account",
    "stats": "Statistics",
    "hashtags": "Hashtags",
    "calendar": "Add to calendar",
    "backupRestore": "Backup & Restore",
    "contactUs": "Contact us",
    "featureRequest": "An idea? A bug?",
    "pendingWrites": "You're synced | 1 update waiting for sync | {n} updates waiting for sync",
    "syncExplanation": "To sync these updates, connect to internet and (re) open Kipinto. If you use several devices, be careful to sync each of them regularly.",
    "anonymousAccount-displayName": "Temporary Account",
    "anonymousAccount-upgrade": "Convert to permanent",
    "anonymousAccount-delete": "Delete the account",
    "anonymousAccount-delete-warning": "<p>If you delete your temporary account, all the data will be lost forever.</p>",
    "restart": "Restart Kipinto"
  },
  "fr": {
    "language": "Langue",
    "title": "Paramètres",
    "disconnect": "Se déconnecter",
    "manageAccount": "Gérer votre compte",
    "stats": "Statistiques",
    "hashtags": "Hashtags",
    "calendar": "Ajouter au calendrier",
    "backupRestore": "Import / Export",
    "contactUs": "Nous contacter",
    "featureRequest": "Une idée ? Un bug ?",
    "pendingWrites": "Vous êtes synchronisé | 1 modif à synchroniser | {n} modifs à synchroniser",
    "syncExplanation": "Pour synchroniser ces modifications, connectez-vous à internet et (re) lancez Kipinto. Si vous utilisez plusieurs appareils, faites attention à bien les synchroniser régulièrement.",
    "anonymousAccount-displayName": "Compte Temporaire",
    "anonymousAccount-upgrade": "Convertir en permanent",
    "anonymousAccount-delete": "Supprimer le compte",
    "anonymousAccount-delete-warning": "<p>Si vous supprimez le compte de test, toutes les données seront perdues.</p>",
    "restart": "Redémarrer Kipinto"
  }
}
</i18n>
